import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const AvisosPage: FC = () => {
  return (
    <>
      <PageTitle>Avisos</PageTitle>
      <View />
    </>
  );
};

export { AvisosPage };
